import React from "react";
import {Grid, Typography, TypographyProps} from "@mui/material";


export type TypographyWithLabelProps = TypographyProps & {
    label?: any
    direction?: "row" | "column"
    LabelTypographyProps?: TypographyProps
    noWrap?: boolean
}


const defaultProps: Partial<TypographyWithLabelProps> = {
    direction: "column",
    noWrap: true
}


export const TypographyWithLabel = ({label, direction, LabelTypographyProps, noWrap, ...props}: TypographyWithLabelProps) => {
    const spacing = "4px";
    return (
        <Grid container direction={direction} wrap="nowrap">
            <Grid item>
                <Typography variant="inputTitle2" color="textSecondary" noWrap display="block" {...LabelTypographyProps}>
                    {label}
                </Typography>
            </Grid>
            <Grid item marginTop={direction == "column" ? spacing : 0} marginLeft={direction == "row" ? spacing : 0}>
                <Typography variant="inputText2" color="primary" noWrap={noWrap} display="block" {...props}/>
            </Grid>
        </Grid>
    )
}
TypographyWithLabel.defaultProps = defaultProps;
